export default "__VITE_ASSET__q8pvVk9W__"